import { useContext } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";
import MobileActionBarContext from "./MobileActionBarContext";

function MobileActionBarContent({ children }) {
  const portalRef = useContext(MobileActionBarContext);

  if (!portalRef?.current) {
    return null;
  }

  return createPortal(children, portalRef.current);
}

MobileActionBarContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MobileActionBarContent;
